import axiosSetup from "../utils/axiosSetup";
import { ProductionCostItem, ProductionCostPagination } from "../store/slices/productionCostSlice";

export interface FetchProductionCostsParams {
  page: number;
  limit: number;
  search: string;
}

export interface ProductionCostResponse {
  items: ProductionCostItem[];
  pagination: ProductionCostPagination;
}

export const fetchProductionCostsApi = async (
  params: FetchProductionCostsParams
): Promise<ProductionCostResponse> => {
  try {
    const res = await axiosSetup.get("/warehouse/admin/production-cost", { params });
    return res.data.data; // { items, pagination }
  } catch (error: any) {
    throw new Error(error.response?.data?.message || error.message || "Failed to fetch");
  }
};